import React from 'react';
export function MegaphoneIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.526 3.15a1.006 1.006 0 00-.973-.045L12.763 6H7a3 3 0 00-3 3v4a3 3 0 003 3h1.322l1.749 4.372a1.002 1.002 0 001.858-.744L10.477 16h2.286l5.79 2.895A1 1 0 0020 18V4a1 1 0 00-.474-.85zM6 13V9a1 1 0 011-1h5v6H7a1 1 0 01-1-1zm12 3.382l-4-2V7.618l4-2v10.764z"
  }));
}